module.exports = __webpack_public_path__ + "static/media/back.f53e7431.svg";